import { useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import {
  useCreatesubscriptionMutation,
  useGetsubscriptionQuery,
  useCencelSubsciptionMutation
} from "../../../store/Reducer/subscription";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";

export default function Subscription() {
  const [activeTab, setActiveTab] = useState("Display");
  const { user } = useSelector((state) => state.Auth);
const { data, isLoading } = useGetsubscriptionQuery({ id: user?.data?._id });
const [createsubscription, { isLoading: createsubscriptionLoading }] =
  useCreatesubscriptionMutation();
const [cancelSubscription, { isLoading: cancelLoading }] =
useCencelSubsciptionMutation(); // Initialize the cancel mutation

  const navigate = useNavigate();
  // The active plans, at most one per product ("display" / "web").
  const subscriptions = Array.isArray(data) ? data : data ? [data] : [];
  const typeKey = (tab) => (tab === "Website" ? "web" : "display");
  const currentOf = (tab) => subscriptions.find((s) => s.type === typeKey(tab));

  const tabContent = {
    Display: [
      {
        title: "Free",
        price: "$0",
        subTitle: "No credit card required",
        features: [
          { name: "No. of Screens: 1", available: true },
          { name: "Slides: 1", available: true },
          { name: "Prayer times", available: true },
          { name: "Announcements: Banner only", available: true },
          { name: "Events", available: false },
          { name: "Images", available: false },
          { name: "Donation", available: false },
        ],
      },
      {
        title: "Standard",
        price: "$29",
        subTitle: "Ideal for single masjid",
        duration: "/month",
        features: [
          { name: "No. of Screens: 3", available: true },
          { name: "Slides: 5", available: true },
          { name: "Prayer times", available: true },
          { name: "Announcements: Full", available: true },
          { name: "Events", available: true },
          { name: "Images", available: true },
          { name: "Donation", available: true },
        ],
        buttonText: "Upgrade",
      },
    ],
    Website: [
      {
        title: "Free",
        price: "$0",
        subTitle: "Basic website functionality",
        features: [
          { name: "Minimal theme", available: true },
          { name: "Prayer times", available: true },
          { name: "Announcements", available: true },
          { name: "News", available: false },
          { name: "Events", available: false },
          { name: "Resources", available: false },
          { name: "Donations", available: false },
          { name: "Team access", available: false },
          { name: "Custom Domain", available: false },
          { name: "Premium Themes", available: false },
          { name: "Premium Support", available: false },
        ],
      },
      {
        title: "Standard",
        price: "$49",
        duration: "/month",
        subTitle: "For advanced use",
        features: [
          { name: "Minimal theme", available: true },
          { name: "Prayer times", available: true },
          { name: "Announcements", available: true },
          { name: "News", available: true },
          { name: "Events", available: true },
          { name: "Resources", available: true },
          { name: "Donations", available: true },
          { name: "Team access", available: true },
          { name: "Custom Domain", available: true },
          { name: "Premium Themes", available: true },
          { name: "Premium Support", available: true },
        ],
        buttonText: "Upgrade",
      },
    ],
    Apps: [
      {
        title: "App Support",
        description: "Get your masjid set up seamlessly",
        contact: "support@masjidhub.com",
        details: [
          "Personalized setup for your masjid.",
          "Quick and seamless integration with your systems.",
          "Dedicated support for any issues or questions.",
        ],
      },
    ],
  };

  const handleSubscribe = async (planTitle, planType) => {
   
    if (!planTitle || !planType) {
      toast.error("Invalid plan or type. Please try again.");
      return;
    }

    if (planTitle?.toLowerCase() === "standard") {
      navigate("/user-dashboard/card", {
        state: { planTitle, planType, plan: currentOf(planType)?.plan },
      });
      return;
    }

    try {
      const data = {
        userId: user?.data?._id || "No User ID", // Debugging user ID
        type: planType?.toLowerCase() === 'website' ? 'web' : 'display',
        plan: planTitle?.toLowerCase(),
      };

      console.log("Data being sent to API:", data); // Debugging API data

      const response = await createsubscription(data).unwrap(); // Ensure proper request handling

      console.log("Subscription successful:", response);
      toast.success("Subscription successful!");
    } catch (error) {
      console.log("Subscription failed:", error?.data?.message || error); // Debugging error response
      toast.error(
        error?.data?.message || "An error occurred while subscribing."
      );
    }
  };
  const handleCancelSubscription = async () => {
   
  
    try {
    
  
      const response = await cancelSubscription({ id: currentOf(activeTab)?.stripeSubscriptionId }).unwrap();
      console.log("Subscription canceled successfully:", response);
      
      toast.success("Subscription canceled successfully.");
    } catch (error) {
      console.error("Subscription cancellation failed:", error);
      toast.error(error?.data?.message || "An error occurred while canceling the subscription.");
    }
  };
  

  return (
    <>
      <section className="min-h-[85vh] bg-gradient-to-b from-slate-50 to-gray-50">
        <div className="max-w-3xl mx-auto py-6 px-8">
          {/* Header Section */}
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold mb-3">
              Simple, transparent pricing
            </h2>
            <p className="text-gray-600 text-sm sm:text-lg max-w-3xl mx-auto">
              Choose the plan that best suits your needs
            </p>
          </div>

          {(createsubscriptionLoading || isLoading) && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="loader border-t-4 border-blue-500 rounded-full w-16 h-16 animate-spin"></div>
              <p className="text-white mt-4">Loading...</p>
            </div>
          )}

          {/* Tabs */}
          <div className="flex justify-center mb-8">
            {["Display", "Website", "Apps"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 mx-2 rounded ${
                  activeTab === tab
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-800"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          {activeTab !== "Apps" ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 gap-6 max-w-6xl mx-auto">
              {tabContent[activeTab].map((plan, index) => {
                 const current = currentOf(activeTab);
                 const isCurrentPlan = current?.plan?.toLowerCase() === plan.title.toLowerCase();
                 // Without a plan for this product the masjid is on Free.
                 const onFree = !current && plan.title.toLowerCase() === "free";
                 return (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200"
                >
                  <div className="px-5 py-5">
                    <h3 className="text-xl font-semibold text-gray-900">
                      {plan.title} Plan
                    </h3>
                    <div className="mt-4 flex items-baseline">
                      <span className="text-4xl font-bold">{plan.price}</span>
                      {plan.duration && (
                        <span className="ml-1 text-lg text-gray-500">
                          {plan.duration}
                        </span>
                      )}
                    </div>
                    <p className="mt-4 text-gray-500">{plan.subTitle}</p>
                  </div>

                  <div className="px-5 pt-0 pb-5">
                   
                    {onFree ? (
                        <div className="mb-6 w-full rounded-md border border-green-600 bg-green-50 px-4 py-2.5 text-center font-medium text-green-700">
                          Your current plan
                        </div>
                      ) : isCurrentPlan ? (
                        <button
                          onClick={
                            handleCancelSubscription
                          }
                          className="mb-6 w-full bg-red-600 hover:bg-red-700 text-white rounded-md px-4 py-2.5 font-medium"
                          disabled={cancelLoading}
                        >
                          {cancelLoading ? "Canceling..." : "Cancel Subscription"}
                        </button>
                      ) : (
                        <button
                          onClick={() => handleSubscribe(plan.title, activeTab)}
                          className="mb-6 w-full bg-blue-600 hover:bg-blue-700 text-white rounded-md px-4 py-2.5 font-medium"
                        >
                          Select Plan
                        </button>
                      )}


                    <ul className="space-y-4">
                      {plan.features.map((feature, i) => (
                        <li
                          key={i}
                          className="flex justify-between items-center"
                        >
                          <span className="text-gray-700">{feature.name}</span>

                          {feature.available ? (
                            <FaCheck className="h-5 w-5 text-green-500" />
                          ) : (
                            <FaTimes className="h-5 w-5 text-red-500" />
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                 )
})}
            </div>
          ) : (
            <div className="w-full mx-auto mb-3 py-3 px-3 text-md bg-blue-100 text-blue-900 rounded-md text-center">
              <span className="text-center">Get in touch through</span>{" "}
              <Link className="font-bold underline" to="/user-dashboard/support">
                Help &amp; support
              </Link>
              <p>We will be happy to set up your masjid.</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
